<template>
    <div>
        <veui-dialog
            :open.sync="modalOpen"
            :closable="false"
            :footless="true"
        >
            <div
                v-visually="{
                    serverId: 19854,
                    area: 'agent-create-dialog-show',
                    isNotRepeat: true,
                    ext: {
                        action: 'show',
                    },
                }"
                class="container"
            >
                <div
                    class="popup-content padding-dialog"
                >
                    <div class="title">系统匹配到一条智能体线索，客户正焦急等待回复</div>
                    <!-- 关闭按钮icon -->
                    <div
                        class="close-btn"
                        @click="handleClose"
                    ></div>
                    <div class="date">
                        <div class="line"></div>
                        <div class="time">{{ currentTime }}日</div>
                        <div class="line"></div>
                    </div>
                    <div class="clue">
                        <div class="clue-sock"></div>
                        <div class="clue-user-info">
                            <div
                                class="clue-user-info-img"
                                :style="'background: url(' + info.avator + ') no-repeat center center / cover'"
                            ></div>
                            <div class="flex-col">
                                <div class="clue-user-info-name">{{ info.nickname || '法行宝用户' }}</div>
                                <div class="clue-user-info-city-phone">{{ info.user_city_name }} | {{ info.user_encode_phone }}</div>
                            </div>
                        </div>
                        <div v-if="info.user_title" class="clue-content">
                            {{ info.user_title }}
                        </div>
                    </div>
                    <div class="desc">您有一条来自智能体的{{ info.domain || '' }}咨询，需在48小时内领取。若未及时开启智能体，客户将被转交给其他律师。请立即开通，第一时间与客户建立联系。</div>
                    <div class="clue-btn">
                        <div class="clue-btn-txt" @click="openAgent">同意并开启智能体</div>
                        <div class="clue-time">距离线索失效：{{ clueClaimCountdown }}</div>
                    </div>
                    <div class="xieyi">点击开启即同意
                        <span class="xieyi-title" @click="clickAgreement">《法行宝律师智能体入驻服务协议》</span>
                    </div>
                </div>
            </div>
        </veui-dialog>
    </div>
</template>

<script>
import {Dialog} from 'veui';
import {mapState, mapActions} from 'vuex';
import {PopupEmitter} from '@/utils/eventEmitter.js';

export default {
    name: 'claimAgentModal',

    components: {
        VeuiDialog: Dialog
    },

    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },

    watch: {
        info: {
            handler(val) {
                this.handleInfo(val);
            },
            immediate: true
        }
    },

    data() {
        return {
            modalOpen: true,
            clueClaimCountdown: '',
            currentTime: '',
            emitter: null // 通信实例
        };
    },
    created() {
        // 获取通信实例
        this.emitter = PopupEmitter.getInstance();
    },
    beforeDestroy() {
        clearTimeout(this.timeCountdown);
        this.timeCountdown = null;
    },

    computed: {
        ...mapState({
            vipInfo: state => state.lawStore?.vipInfo
        })
    },

    methods: {
        ...mapActions({
            getAgentData: 'lawStore/getAgentData'
        }),

        openAgent() {
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            this.$wywLog.send({
                serverId: 19854,
                area: 'agent-create-dialog-open',
                action: 'click'
            });
            // 请求接口
            this.$http.post('/bp/api/lawyeragent/createbyuid')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$toast.success('已提交智能体创编申请，线索已成功解锁');
                        // 刷新智能体信息
                        this.getAgentData();
                        this.emitter?.emit('claim-agent-modal-close');
                        this.changeModalOpen(false);
                        return;
                    }
                    this.$toast.error(res && res.msg || '提交失败，请稍后再试～');
                })
                .catch(() => {
                    this.$toast.error('提交失败，请稍后再试～');
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        handleInfo(info) {
            if (info && info.id) {
                const nowDate = new Date();
                const year = nowDate.getFullYear();
                const month = String(nowDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始
                const day = String(nowDate.getDate()).padStart(2, '0');
                this.currentTime = `${year}年${month}月${day}`;
                info.createTimeFormat = info.create_time && info.create_time.replace('年', '/').replace('月', '/').replace('日', ' ').replace('时', ':').replace('分', ':').replace('秒', '');
                const now = new Date().getTime();
                const endTime = new Date(info.createTimeFormat).getTime() + 48 * 60 * 60 * 1000;
                const total = endTime - now;
                const days = Math.floor(total / (1000 * 60 * 60 * 24)) || 0;
                const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((total / 1000 / 60) % 60);
                const seconds = Math.floor((total / 1000) % 60);
                if (total < 0) {
                    return;
                }
                this.handleCountdown({
                    days,
                    hours,
                    minutes,
                    seconds
                });
            }
        },

        handleCountdown(timestamp) {
            clearTimeout(this.timeCountdown);
            this.timeCountdown = null;
            let {days, hours, minutes, seconds} = timestamp;
            if (days + hours + minutes + seconds === 0) {
                this.handleClose();
                return;
            }
            this.clueClaimCountdown = `${days ? days * 24 + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
            seconds = seconds - 1;
            if (seconds < 0) {
                seconds = 59;
                minutes = minutes - 1;
            }
            if (minutes < 0) {
                minutes = 59;
                hours = hours - 1;
            }
            if (hours < 0) {
                hours = 23;
                days = days - 1;
            }
            this.timeCountdown = setTimeout(() => {
                this.handleCountdown({
                    days,
                    hours,
                    minutes,
                    seconds
                });
            }, 1000);
        },

        // 弹窗显示切换
        changeModalOpen(open) {
            clearTimeout(this.timeCountdown);
            this.timeCountdown = null;
            this.modalOpen = open;
        },

        // 点击关闭按钮
        handleClose() {
            this.changeModalOpen(false);
            this.$wywLog.send({
                serverId: 19854,
                area: 'agent-create-dialog-close',
                action: 'click'
            });
        },
        // 点击协议
        clickAgreement() {
            window.open('https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf');
        }
    }
};
</script>

<style lang="less" scoped>
::v-deep .veui-dialog-content {
    width: 660px;
    padding: 0 30px;
    box-sizing: border-box;
    border-radius: 8px;

    .veui-dialog-content-head {
        display: none;
    }

    .veui-dialog-content-body {
        padding: 0;
        overflow: visible;
    }
}


.popup-content {
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    line-height: 1;
    color: #1e1f24;
    background-color: #fff;
    padding: 30px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
        margin: auto;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 12px;
        line-height: 20px;
        text-align: center;
        color: #000;
    }
    .close-btn {
        z-index: 1;
        height: 24px;
        width: 24px;
        position: absolute;
        right: 0;
        top: 30px;
        background: url('https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/close-icon.png') no-repeat center center / 100%;
        cursor: pointer;
    }
    .date {
        display: flex;
        align-items: center;
        color: #333;
        text-align: center;
        justify-content: center;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
        margin-bottom: 18px;
    }
    .clue {
        width: 600px;
        background: #edf6ff;
        border-radius: 16px;
        position: relative;
        overflow: hidden;
        padding: 24px;
        box-sizing: border-box;
        .clue-sock {
            position: absolute;
            width: 66px;
            height: 66px;
            right: -4px;
            top: -12px;
        }
        .clue-user-info {
            display: flex;
            align-items: center;
            .clue-user-info-img {
                min-width: 40px;
                max-width: 40px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 8px;
            }
            .flex-col {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .clue-user-info-name {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-style: Medium;
                    font-size: 16px;
                    line-height: 16px;
                    color: #1f1f1f;
                }
                .clue-user-info-city-phone {
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 14px;
                    margin-top: 8px;
                    color: #525252;
                }
            }
        }
        .clue-content {
            font-family: PingFang SC;
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 26px;
            text-align: left;
            margin-top: 16px;
            filter: blur(5px);
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            word-wrap: break-word;
        }
    }
    .desc {
        color: #333;
        font-size: 16px;
        line-height: 24px;
        margin-top: 18px;
        text-align: center;
    }
    .clue-btn {
        width: 190px;
        height: 40px;
        background: #05f;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        padding: 6px 0;
        border-radius: 4px;
        margin-top: 24px;
        cursor: pointer;
        .clue-btn-txt {
            font-family: PingFang SC;
            font-weight: 600;
            font-style: Semibold;
            font-size: 14px;
            line-height: 14px;
        }
        .clue-time {
            font-family: PingFang SC;
            font-weight: 400;
            font-style: Regular;
            font-size: 10px;
            line-height: 10px;
            text-align: center;
            opacity: 0.8;
            margin-top: 4px;
        }
    }
    .xieyi {
        color: #858581;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        line-height: 1;
        margin-top: 12px;
        text-align: center;

        .xieyi-title {
            color: #05f;
            cursor: pointer;
        }
    }
}

</style>